// extracted by mini-css-extract-plugin
export default {"group":"create_folder_form-module__group--fGvwA","input":"create_folder_form-module__input--1gP9A","error":"create_folder_form-module__error--1IWEd"};